(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["blueberry_quiz"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shire-quiz')) {
    customElements.define('shire-quiz', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.answers = ['', ''];
        this.step1 = this.querySelector('[data-step="1"]');
        this.step2 = this.querySelector('[data-step="2"]');
        this.btn = this.querySelector('[data-go]');
        this.progress = this.querySelector('[data-progress]');
        this.err = this.querySelector('[data-error]');
        if (!this.step1 || !this.step2 || !this.btn) return;
        this.btnLabel = this.btn.textContent;

        // The main button is wired up first so nothing optional can stop it working
        this.btn.addEventListener('click', () => this.go());

        this.step1.addEventListener('change', (e) => {
          if (e.target.type !== 'radio') return;
          this.answers[0] = e.target.value;
          this.show(2);
        });
        this.step2.addEventListener('change', (e) => {
          if (e.target.type !== 'radio') return;
          this.answers[1] = e.target.value;
          this.btn.disabled = false;
        });

        // Back link is optional (Display > Show Back link)
        const back = this.querySelector('[data-back]');
        if (back) back.addEventListener('click', () => this.show(1));
      }

      fail(message) {
        if (!this.err) return;
        this.err.textContent = message;
        this.err.hidden = false;
      }

      show(n) {
        this.step1.hidden = n !== 1;
        this.step2.hidden = n !== 2;
        if (this.progress) this.progress.textContent = 'Question ' + n + ' of 2';
        if (this.err) this.err.hidden = true;
        const first = (n === 1 ? this.step1 : this.step2).querySelector('input:checked, input');
        if (first) first.focus();
      }

      async go() {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const variant = this.dataset.variant;
        let target = this.dataset.url || (variant ? root + 'checkout' : '');
        if (!target) { this.fail('Add a link or a product to this block in the theme editor.'); return; }

        this.btn.disabled = true;
        this.btn.textContent = 'One moment…';

        const attrs = {
          [this.dataset.attr1 || 'Blueberry use']: this.answers[0],
          [this.dataset.attr2 || 'Packs per day']: this.answers[1],
          'Quiz source': location.pathname
        };
        const post = (path, body) => fetch(root + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });

        try {
          // 1. Add the product to the shopper's current cart (keeps everything in one cart)
          if (variant) {
            const add = await post('cart/add.js', { items: [{ id: Number(variant), quantity: Number(this.dataset.qty) || 1 }] });
            if (!add.ok) throw new Error((await add.json()).description || 'Could not add to cart.');
          }
          // 2. Save the answers on that cart; they are copied onto the order at checkout
          const upd = await post('cart/update.js', { attributes: attrs });
          if (!upd.ok) throw new Error('Could not save your answers.');
        } catch (e) {
          this.fail(e.message || 'Something went wrong. Try again.');
          this.btn.disabled = false;
          this.btn.textContent = this.btnLabel;
          return;
        }

        const url = new URL(target, location.origin);
        // Cart permalinks (/cart/VARIANT:QTY) start a fresh cart, so the answers go in the link itself.
        // Works for a bare permalink and for /discount/CODE?redirect=/cart/VARIANT:QTY
        const isPermalink = (path) => /\/cart\/\d+:\d+/.test(path);
        const addAttrs = (u) => Object.entries(attrs).forEach(([k, v]) => u.searchParams.set('attributes[' + k + ']', v));
        if (isPermalink(url.pathname)) addAttrs(url);
        const redirect = url.searchParams.get('redirect');
        if (redirect) {
          const r = new URL(redirect, location.origin);
          if (isPermalink(r.pathname)) {
            addAttrs(r);
            url.searchParams.set('redirect', r.pathname + r.search);
          }
        }
        if (this.dataset.discount && /\/(checkout|cart)/.test(url.pathname)) url.searchParams.set('discount', this.dataset.discount);
        window.location.href = url.toString();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
